export default __webpack_public_path__ + "static/media/Body_C1.5684e397.svg";